<template>
    <div class="footer">
        <partners />
        <div class="container">
            <!--<div class="content-layout">
                <div class="column column__small">
                    <div class="block">
                        <div class="title">
                            <i class="fas fa-search fa-fw" />
                            Seneste
                        </div>
                        <div class="body" v-if="lookups !== null && lookups.rows">
                            <br>
                            <div class="list">
                                <div class="vehicle" v-for="(lookup, index) in latestLookups" v-if="index < 5" v-bind:key="lookup.id" @click="goToVehicle(lookup.licenseplate.split(' ').join(''))">
                                    <div class="name">
                                        {{ lookup.vehicle.brand }}
                                        {{ lookup.vehicle.model }}
                                        <div class="small">
                                            {{ lookup.vehicle.variant }}
                                        </div>
                                    </div>
                                    <div class="big-value numberplate">
                                        {{ lookup.licenseplate.toUpperCase() }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column column__small">
                    <div class="block">
                        <div class="title">
                            <i class="fas fa-repeat fa-fw" />
                            Mest søgte
                        </div>
                        <div class="body">
                            <br>
                            <div class="list">
                                <div class="vehicle" v-for="(vehicle, index) in vehiclesSortedByLookups" v-if="index < 5" @click="goToVehicle(vehicle.lookups[0].licenseplate.split(' ').join(''))">
                                    <div class="name">
                                        {{ vehicle.brand }}
                                        {{ vehicle.model }}
                                        <div class="small">
                                            {{ vehicle.variant }}
                                        </div>
                                    </div>
                                    <div class="big-value">
                                        {{ vehicle.lookupCount }}
                                        <i class="fal fa-search fa-fw" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column column__small">
                    <div class="block">
                        <div class="title">
                            <i class="fas fa-tachometer-alt-fast fa-fw" />
                            Flest HK
                        </div>
                        <div class="body">
                            <br>
                            <div class="list">
                                <div class="vehicle" v-for="(vehicle, index) in vehiclesSortedByHorsepower" v-if="index < 5" v-bind:key="vehicle.id" @click="goToVehicle(vehicle.lookups[0].licenseplate.split(' ').join(''))">
                                    <div class="name">
                                        {{ vehicle.brand }}
                                        {{ vehicle.model }}
                                        <div class="small">
                                            {{ vehicle.variant }}
                                        </div>
                                    </div>
                                    <div class="big-value">
                                        {{ vehicle.horsepower }} HK
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
            <div class="stats content-layout" v-if="showStatsCount > 4">
                <div class="lookups column column__xs">
                    <span>
                        {{ newTotalLookups | thousand }}
                    </span>
                    søgn. i alt
                </div>
                <br>
                <div class="lookups column column__xs">
                    <span>
                        {{ newTotalVehicles | thousand }}
                    </span>
                    køretøjer
                </div>
                <br>
                <div class="lookups column column__xs">
                    <span>
                        {{ newLookupsYesterday | thousand }}
                    </span>
                    søgn. i går
                </div>
                <br>
                <div class="lookups column column__xs">
                    <span>
                        {{ newLookupsToday | thousand }}
                    </span>
                    søgn. i dag
                </div>
                <br><br>
            </div>
            <div v-if="showStatsCount > 9">
                <a href="https://online.adservicemedia.dk/cgi-bin/click.pl?pid=33267&cid=7110&productGroup=Samlino" target="_blank" rel="noopener">
                    Lead
                </a>
            </div>
            <div class="copyright">
                <div style="opacity:.5;">
                    NrPladeTjek.dk er ikke ansvarlige for fejl i de viste oplysninger, da alle oplysninger er hentet fra offentlige registre.
                    <br><br>
                    <a href="mailto:kontakt@nrpladetjek.dk">Kontakt os</a> ved spørgsmål eller feedback om vores side.
                </div>
                <hr style="opacity:.15;">
                <div class="copyright-line">
                    2019 &copy;
                    <span @click="showStats()">
                        NrPladeTjek.dk
                    </span>
                    &nbsp;&nbsp;|&nbsp;&nbsp;
                    Udviklet og drevet af <a href="https://deveo.dk" target="_blank" rel="noopener">Deveo ApS</a>
                </div>
                <div class="copyright-line mobile">
                    2019 &copy;
                    <span @click="showStatsCount = showStatsCount + 1">
                        NrPladeTjek.dk
                    </span>
                    <br><br>
                    Udviklet og drevet af <a href="https://deveo.dk" target="_blank" rel="noopener">Deveo ApS</a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../../styles/vars";

    .footer {
        padding: 50px 0;
        background: darken($color--main, 10%);

        .container {
            // border-top: 1px solid rgba(255, 255, 255, 0.15);
            padding-top: 50px;

            @media screen and (max-width: $small) {
                border: none !important;
                padding-top: 0px !important;
            }
        }

        .block {
            background: transparent;
            box-shadow: none;

            .title {
                color: #fff;
                text-align: center;
            }

            .body {
                overflow: inherit;
            }
        }

        .stats {
            margin: 0 0 50px 0;

            @media screen and (max-width: $medium) {
                .lookups {
                    flex: 0 0 calc(50% - 15px) !important;
                    margin-bottom: 15px !important;
                }
            }

            @media screen and (max-width: $small) {
                .lookups {
                    flex: 0 0 100% !important;
                    margin-bottom: 15px !important;
                }
            } 

            .lookups,
            .vehicles {
                margin: 0 auto;
                width: 250px;
                max-width: 100%;
                background: #fff;
                padding: 15px 30px;
                font-weight: 400;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 2px;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                text-transform: uppercase;

                span {
                    font-size: 30px;
                    font-weight: 600;
                    padding-right: 15px;
                }
            }
        }

        .copyright {
            color: #fff;
            text-align: center;
            user-select: none;

            @media screen and (max-width: $small) {
                padding-bottom: 70px;
            }
        }

        .copyright-line.mobile {
            display: none;
        }

        @media screen and (max-width: $small) {
            .copyright-line {
                display: none;
            }
            
            .copyright-line.mobile {
                display: block;
            }
        }

        .list {

            .vehicle {
                display: flex;
                align-items: center;
                background: #fff;
                margin-bottom: 15px;
                padding: 15px;
                border-radius: 2px;
                box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.15);
                transition: 0.3s ease all;
                cursor: pointer;
                font-weight: 600;
                margin-left: -30px;
                margin-right: -30px;

                &:hover {
                    transform: translateX(4px);
                }

                .big-value {
                    font-weight: 600;
                    margin-left: 15px;

                    &.numberplate {
                        flex: 0 0 120px;
                        background: url('/static/licenseplate4.png') center center no-repeat;
                        background-size: cover;
                        width: 120px;
                        height: 35px;
                        padding: 5px 7px 8px 20px;
                        font-family: 'Arial';
                        font-weight: 900;
                        text-align: center;
                    }
                }

                .position {
                    font-weight: 600;
                    font-size: 18px;
                    flex: 0 0 15%;
                    white-space: nowrap;
                }

                .name {
                    flex-grow: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    .small {
                        font-size: 12px;
                        opacity: .5;
                        width: 100%;
                        max-width: 100%;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }

                .big-value {
                    font-size: 18px;
                    padding-left: 10px;
                    text-align: right;
                    white-space: nowrap;
                }
            }
        }

        a {
            color: inherit;
            text-decoration: underline;
        }
    }

</style>

<script>
import * as lookupService from '@/services/lookup/lookupService'
import * as vehicleService from '@/services/vehicle/vehicleService'
import _ from 'lodash'
import Partners from './partners'
import moment from 'moment'
import axios from 'axios'

export default {
    data () {
        return {
            lookups: null,
            vehicles: null,
            showStatsCount: 0,
            newTotalLookups: 0,
            newTotalVehicles: 0,
            newLookupsYesterday: 0,
            newLookupsToday: 0
        }
    },
    created () {
        // this.getLookups()
        /* setInterval(() => {
            this.getLookups()
        }, 10000) */
        // this.getVehicles()
        this.getNewData()
        this.checkIfAdmin()
    },
    components: {
        Partners
    },
    methods: {
        checkIfAdmin () {
            let url = window.location.href
            if (url.includes('admin=true')) {
                this.showStatsCount = 5
                this.updateRealtime(false)
            }
        },
        getLookups () {
            lookupService.findAll({}, (response) => {
                this.lookups = response.data
            })
        },
        getVehicles () {
            vehicleService.findAll({}, (response) => {
                let arr = []
                response.data.forEach((vehicle) => {
                    if (vehicle.horsepower < 1500) {
                        arr.push(vehicle)
                    }
                })
                this.vehicles = arr
            })
        },
        goToVehicle (licenseplate) {
            window.location.href = '/soeg/' + licenseplate + '/overblik'
        },
        reloadLookups () {
            this.getNewData()
            /* this.getLookups()
            this.getVehicles() */
        },
        showStats () {
            this.showStatsCount = this.showStatsCount + 1
            if (this.showStatsCount === 5) {
                this.updateRealtime(true)
            }
        },
        getNewData () {
            axios.get('https://api.nrpladetjek.dk/api/lookups/count').then(response => (this.newTotalLookups = response.data.count))
            axios.get('https://api.nrpladetjek.dk/api/vehicles/count').then(response => (this.newTotalVehicles = response.data.count))
            axios.get('https://api.nrpladetjek.dk/api/lookups/count/yesterday').then(response => (this.newLookupsYesterday = response.data.count))
            axios.get('https://api.nrpladetjek.dk/api/lookups/count/today').then(response => (this.newLookupsToday = response.data.count))
        },
        updateRealtime (showNotification) {
            if (showNotification) {
                alert('God Mode activated - Du kan nu se stats! Alle stats opdateres hvert 10. sekund i God Mode.')
            }
            setInterval(() => {
                this.getNewData()
            }, 10000)
        }
    },
    watch: {
        '$store.state.vehicleData.general.RegNr': 'reloadLookups'
    },
    computed: {
        vehiclesSortedByHorsepower () {
            function compare (a, b) {
                if (a.horsepower < b.horsepower) {
                    return 1
                }
                if (a.horsepower > b.horsepower) {
                    return -1
                }
                return 0
            }
            if (this.vehicles !== null && this.vehicles.length > 0) {
                return this.vehicles.sort(compare)
            }
        },
        vehiclesSortedByLookups () {
            let arr = []
            let excludeLicenseplates = [
                'AL52114',
                'AA88470',
                'AL52111',
                'BV73090',
                'BP59902',
                'BK83307',
                'YE58285',
                'HS13956',
                'TESLA'
            ]
            if (this.vehicles !== null && this.vehicles.length > 0) {
                this.vehicles.forEach((vehicle) => {
                    if (!excludeLicenseplates.includes(vehicle.lookups[0].licenseplate.toUpperCase())) {
                        vehicle.lookupCount = vehicle.lookups.length
                        arr.push(vehicle)
                    }
                })
            }
            /* function compare (a, b) {
                if (a.brand < b.brand) {
                    return 1
                }
                if (a.brand > b.brand) {
                    return -1
                }
                return 0
            } */
            if (this.vehicles !== null && this.vehicles.length > 0) {
                // return vehicles.sort(compare)
                // return this.vehicles
                return _.orderBy(arr, 'lookupCount', 'desc')
            }
        },
        latestLookups () {
            let indexes = []
            let arr = []
            this.lookups.rows.forEach((lookup, index) => {
                let licenseplate = lookup.licenseplate.toUpperCase()
                if (licenseplate.match(/[A-Z{1}]+[A-Z{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]+[0-9{1}]/g) && licenseplate.length === 7) {
                    let splittedString = licenseplate.split('')
                    splittedString.splice(2, 0, ' ')
                    splittedString.splice(5, 0, ' ')
                    splittedString = splittedString.join('')
                    lookup.licenseplate = splittedString.toUpperCase()
                }
                if (index === 0) {
                    indexes.push(lookup.vehicle.id)
                    arr.push(lookup)
                } else {
                    if (!indexes.includes(lookup.vehicle.id)) {
                        indexes.push(lookup.vehicle.id)
                        arr.push(lookup)
                    }
                }
            })
            return arr
        },
        lookupsToday () {
            let excludeLicenseplates = [
                'AL52114',
                'AA88470',
                'AL52111',
                'BV73090',
                'BP59902',
                'BK83307',
                'YE58285',
                'HS13956',
                'TESLA'
            ]
            let count = 0
            let d = new Date()
            d.setHours(0, 0, 0, 0)
            let today = moment(d).format('X')
            this.lookups.rows.forEach((lookup) => {
                let createdDate = moment(lookup.createdAt).add(2, 'hours').format('X')
                let licenseplate = lookup.licenseplate.split(' ').join('')
                if (!excludeLicenseplates.includes(licenseplate.toUpperCase()) && createdDate > today) {
                    count++
                }
            })
            return count
        },
        lookupsYesterday () {
            let excludeLicenseplates = [
                'AL52114',
                'AA88470',
                'AL52111',
                'BV73090',
                'BP59902',
                'BK83307',
                'YE58285',
                'HS13956',
                'TESLA'
            ]
            let count = 0
            let d = new Date()
            d.setHours(0, 0, 0, 0)
            let today = moment(d).format('X')
            this.lookups.rows.forEach((lookup) => {
                let createdDate = moment(lookup.createdAt).add(2, 'hours').format('X')
                let licenseplate = lookup.licenseplate.split(' ').join('')
                if (!excludeLicenseplates.includes(licenseplate.toUpperCase()) && createdDate < today && createdDate > (today - 86400)) {
                    count++
                }
            })
            return count
        }
    }
}
</script>



// WEBPACK FOOTER //
// footer.vue?1619503f